// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.fi-vimeo-player {
  display: block;
  width: 100%;
  height: 100%;
  padding: 0;
}
.fi-vimeo-player.vimeo-preview-Large {
  max-width: 820px;
}
.fi-vimeo-player.vimeo-preview-Normal {
  max-width: 480px;
}
.fi-vimeo-player.vimeo-preview-Medium {
  max-width: 370px;
}
.fi-vimeo-player.vimeo-preview-Small {
  max-width: 240px;
}
.fi-vimeo-player.vimeo-preview-XS {
  max-width: 147px;
}
.fi-vimeo-player .fi-vimeo-player-preview-container {
  cursor: pointer;
  position: relative;
}
.fi-vimeo-player .fi-vimeo-player-preview-container:not(.editor-mode):hover .fi-vimeo-player-preview-icon .mat-icon {
  color: var(--fi-vimeo-player-preview-icon-color-hover);
}
.fi-vimeo-player .fi-vimeo-player-preview-container .fi-vimeo-player-preview-image {
  max-width: 100%;
}
.fi-vimeo-player .fi-vimeo-player-preview-container .fi-vimeo-player-preview-icon {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  height: 50%;
  width: 50%;
}
.fi-vimeo-player .fi-vimeo-player-preview-container .fi-vimeo-player-preview-icon .mat-icon {
  height: 100%;
  width: 100%;
  opacity: 0.7;
  text-align: center;
  display: block;
  transition: 0.2s;
  color: var(--fi-vimeo-player-preview-icon-color);
}`, "",{"version":3,"sources":["webpack://./Source/app/shared/media-bank/fi-vimeo/fi-vimeo-player.component.scss"],"names":[],"mappings":"AAAA;EACI,cAAA;EACA,WAAA;EACA,YAAA;EACA,UAAA;AACJ;AAAI;EACI,gBAAA;AAER;AAAI;EACI,gBAAA;AAER;AAAI;EACI,gBAAA;AAER;AAAI;EACI,gBAAA;AAER;AAAI;EACI,gBAAA;AAER;AAAI;EACI,eAAA;EAQA,kBAAA;AALR;AAAgB;EACI,sDAAA;AAEpB;AAGQ;EACI,eAAA;AADZ;AAGQ;EACI,kBAAA;EACA,QAAA;EACA,SAAA;EACA,gCAAA;EACA,WAAA;EACA,UAAA;AADZ;AAEY;EACI,YAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,cAAA;EACA,gBAAA;EACA,gDAAA;AAAhB","sourcesContent":[".fi-vimeo-player {\r\n    display: block;\r\n    width: 100%;\r\n    height: 100%;\r\n    padding: 0;\r\n    &.vimeo-preview-Large {\r\n        max-width: 820px;\r\n    }\r\n    &.vimeo-preview-Normal {\r\n        max-width: 480px;\r\n    }\r\n    &.vimeo-preview-Medium {\r\n        max-width: 370px;\r\n    }\r\n    &.vimeo-preview-Small {\r\n        max-width: 240px;\r\n    }\r\n    &.vimeo-preview-XS {\r\n        max-width: 147px;\r\n    }\r\n    .fi-vimeo-player-preview-container {\r\n        cursor: pointer;\r\n        &:not(.editor-mode) {\r\n            &:hover {\r\n                .fi-vimeo-player-preview-icon .mat-icon {\r\n                    color: var(--fi-vimeo-player-preview-icon-color-hover);\r\n                }\r\n            }\r\n        }\r\n        position: relative;\r\n        .fi-vimeo-player-preview-image {\r\n            max-width: 100%;\r\n        }\r\n        .fi-vimeo-player-preview-icon {\r\n            position: absolute;\r\n            top: 50%;\r\n            left: 50%;\r\n            transform: translate(-50%, -50%);\r\n            height: 50%;\r\n            width: 50%;\r\n            .mat-icon {\r\n                height: 100%;\r\n                width: 100%;\r\n                opacity: 0.7;\r\n                text-align: center;\r\n                display: block;\r\n                transition: 0.2s;\r\n                color: var(--fi-vimeo-player-preview-icon-color);\r\n            }\r\n        }\r\n    }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
